import React from "react";
import { Ban, ShieldCheck, TrendingUp, Heart } from "lucide-react";

const BusinessValue = () => {
  const points = [
    {
      icon: Ban,
      title: "Ingen drift",
      description: "Vi håndterer alt – du trenger ikke gjøre noe",
    },
    {
      icon: ShieldCheck,
      title: "Ingen risiko",
      description: "Gratis å ha stasjonen – ingen kostnader for deg",
    },
    {
      icon: TrendingUp,
      title: "Økt omsetning",
      description: "Gjester blir lenger når de kan lade telefonen",
    },
    {
      icon: Heart,
      title: "Bedre kundeopplevelse",
      description: "Tilby en etterspurt tjeneste kundene setter pris på",
    },
  ];

  return (
    <section
      id="business-value"
      className="py-20 md:py-28 bg-[#0A0A0A] relative overflow-hidden"
      data-testid="business-value-section"
    >
      {/* Subtle gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#FFD84D]/5 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white font-['Outfit'] mb-4">
            Tjen penger <span className="text-[#FFD84D]">uten arbeid</span>
          </h2>
          <p className="text-lg text-[#A1A1AA] max-w-2xl mx-auto">
            En B-Labs stasjon gir deg passiv inntekt uten at du trenger å løfte en finger.
          </p>
        </div>

        {/* Points Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {points.map((point, index) => (
            <div
              key={index}
              className="bg-[#121212] border border-white/5 rounded-2xl p-6 text-center card-hover group"
              data-testid={`business-point-${index + 1}`}
            >
              {/* Icon */}
              <div className="w-14 h-14 mx-auto mb-4 bg-[#FFD84D]/10 rounded-xl flex items-center justify-center group-hover:bg-[#FFD84D]/20 transition-colors">
                <point.icon className="w-7 h-7 text-[#FFD84D]" />
              </div>

              {/* Content */}
              <h3 className="text-lg font-semibold text-white mb-2 font-['Outfit']">
                {point.title}
              </h3>
              <p className="text-sm text-[#A1A1AA] leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessValue;
